
<template>
    <iframe :src="pdfData" width="100%" :height="parentHeight" style="border: none;"></iframe>
</template>

<script>
import settings from "@/backend/LocalSettings"
import BasePage from '@/pages/Admin/BasePage' 
import Constants from '@/backend/Constants'
export default {
    name: "inspectie_finala_pdf",
    extends: BasePage,

    data(){
        return {
            Constants: Constants,
            start: 'undefined',   
            stop: 'undefined',   
            parentHeight: 1000,   
            pdfData:'',     
        }
    },
    methods: {
        genereaza() {  
            //this.parentHeight   = this.$parent.$el.offsetHeigh                            
            this.start         = this.$route.params.start    
            this.stop          = this.$route.params.stop    
        },

    },

    async mounted() {

        var  response = await this.$http.post('login/check_php_login', {token: settings.get_token} );
        if(response) {
            if(response.body.token_activ == 0){
                this.$router.push("/");
            }else{
                this.genereaza()
                this.pdfData = this.Constants.ServerUrl + '/receptie/devize/raport_rar_din_vue/' + this.start + '/' + this.stop
            }
        } else {
            this.$router.push("/");
        }
    }
}
</script>

